import React from 'react';
import { Channel } from 'js/model/rainbow/content/ChannelOutput';
import { CmsVenueReviewsPage } from 'js/model/cms/cms-venue-reviews-page';
import { createHeaderViewModel } from 'js/model/view/venue-reviews-page/header';
import { VenueReviewsDetails } from 'js/model/rainbow/venue-reviews-page/VenueReviewsDetails';
import { VenueReviews } from 'js/pages/VenuePage/VenueReviewsSection/VenueReviews';
import { PaginationOutput } from 'js/model/rainbow/PaginationOutput';
import { createVenueTypeLinksViewModel } from 'js/model/view/venue-reviews-page/venue-type-links';
import { VenuePage } from 'js/model/rainbow/page/VenuePageOutput';
import { Context } from 'js/components/LocaleWrapper';
import { useTrackPageAndSessionView } from 'js/hooks/useTrackPageAndSessionView';
import { Header } from './Header';
import styles from './VenueReviewsPage.module.css';

export function VenueReviewsPage(): React.ReactElement {
  const context = React.useContext(Context);
  useTrackPageAndSessionView();

  function generatePaginationUri(pageNumber: number): string {
    const venueDetails = context.pageData.venueReviews
      .venueReviewDetails as VenueReviewsDetails;
    if (pageNumber === 1) {
      return context.generateUri('venue', {
        normalisedName: venueDetails.normalisedName,
      });
    }
    return context.generateUri('venueReviews', {
      normalisedName: venueDetails.normalisedName,
      page: pageNumber,
    });
  }

  const cms = context.pageData.cms as CmsVenueReviewsPage;
  const pagination = context.pageData.venueReviews.venueReviews
    .pagination as PaginationOutput;
  const { ...requestData } = context.pageData;
  const headerViewModel = createHeaderViewModel(
    context.channel,
    cms,
    context.pageData.venueReviews.venueReviewDetails as VenueReviewsDetails,
    context.pageData.venueReviews.venueBreadcrumbs,
    context.generateUri
  );
  const venueTypeLinksViewModel = createVenueTypeLinksViewModel(
    cms,
    context.pageData.venueReviews.venueTypeUris
  );

  return (
    <>
      <Header {...headerViewModel} />
      <section className={styles.reviewsSection}>
        <div className={styles.preamble}>
          <p>{cms.page['venue-reviews'].preamble}</p>
        </div>

        <VenueReviews
          channelData={context.channel as Channel}
          i18n={context.i18n}
          requestData={requestData}
          venue={
            {
              venue: {
                id: context.pageData.venueReviews.venueReviewDetails.venueId,
                rating: context.pageData.venueReviews.venueReviewDetails.rating,
              },
              venueReviews: {
                ratingHistogram:
                  context.pageData.venueReviews.venueReviews.ratingHistogram,
                reviews: context.pageData.venueReviews.venueReviews.reviews,
                treatmentCategoryOverallRatingAverages:
                  context.pageData.venueReviews.venueReviews
                    .treatmentCategoryOverallRatingAverages,
              },
            } as VenuePage
          }
          pagination={pagination}
          generatePaginationUri={generatePaginationUri}
          venueTypeLinks={venueTypeLinksViewModel}
        />
      </section>
    </>
  );
}
